import React from 'react';

/**
 * The masthead shared by the four public pages: Desktop, Reco, Spatial Models
 * and the Gallery.
 *
 * Reco set the pattern — the product name at a modest size in the accent, one
 * line of plain promise underneath — and it is the only one of the four that
 * already sat inside a single screen. The others carried display headlines two
 * or three steps larger, which read as three unrelated sites and cost the room
 * their calls to action needed. This is that pattern, in one place, so the four
 * stay in step.
 *
 * Anything more than the name and the promise belongs to the page, not here.
 */
const PageMasthead: React.FC<{ title: string; tagline: string }> = ({ title, tagline }) => (
  <>
    <h1 className="text-balance font-brand text-2xl font-light tracking-tight text-crane-500 sm:text-3xl">
      {title}
    </h1>
    <p className="mt-2.5 max-w-xl text-balance font-brand text-body font-light text-ink-300">
      {tagline}
    </p>
  </>
);

export default PageMasthead;
